// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2LVkk","content":"Consent_content__2R9vM","footer":"Consent_footer__T_ljk"};